// stores/useCalculatingDevices.ts
import create from 'zustand'

type VirtualMetersLoadingStoreActions = {
  deviceIds: Set<string>
  addDeviceId: (id: string) => void
  removeDeviceId: (id: string) => void
  getDeviceIds: () => string[]
}

export const useVirtualMetersLoadingStore = create<VirtualMetersLoadingStoreActions>((set, get) => ({
  deviceIds: new Set(),

  addDeviceId: id => {
    set(state => {
      const updatedSet = new Set(state.deviceIds)
      updatedSet.add(id)
      return { deviceIds: updatedSet }
    })
  },

  removeDeviceId: id => {
    set(state => {
      const updatedSet = new Set(state.deviceIds)
      updatedSet.delete(id)
      return { deviceIds: updatedSet }
    })
  },

  getDeviceIds: () => Array.from(get().deviceIds),
}))
